import React, { useEffect, useRef, useState } from 'react';
import style from './logo.module.css';
import cloudimg from '../../../assets/images/svgs/cloud-upload-svgrepo-com.svg';
import axios from 'axios';
import { SuccessToast, ErrorToast } from '../../../components/toastMessage';
import { BASE_URL } from '../../../constants/Constants';
import { FileUploader } from "react-drag-drop-files";
import { useNavigate } from 'react-router-dom';
import uploadImage from '../../../utils/azure-storage-blob';
import BoxComponent from '../../../components/CommonComponents/BoxComponent/BoxComponent';
import { _axios } from '../../../utils/axios';

const fileTypes = ["JPG", "PNG", "GIF", "JPEG"];

const Logo = () => {
  const [file, setFile] = useState<any>()
  const [favIcon, setFavIcon] = useState<any>()
  const logoRef = useRef<any>(null)
  const faviconRef = useRef<any>(null)
  const navigate = useNavigate()
  const [existingLogo, setExistingLogo] = useState<string>('');
  const [existingFavicon, setExistingFavicon] = useState<string>('');
  const [logoUrl, setLogoUrl] = useState<string>('');
  const [faviconUrl, setFaviconUrl] = useState<string>('');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchImages = async () => {
      try {
        // Fetch logo
        const logoResponse = await _axios.get(`${BASE_URL}/api/logo`);
        if (logoResponse.data.success === 1) {
          setLogoUrl(logoResponse.data.url);
          if (logoResponse.data.filename) {
            setExistingLogo(logoResponse.data.filename);
          }
        }

        // Fetch favicon with error handling
        try {
          const faviconResponse = await _axios.get(`${BASE_URL}/api/favicon`);
          // console.log("Full favicon response:", faviconResponse.data);

          if (faviconResponse.data?.filename) {
            setFaviconUrl(faviconResponse.data.filename);
          } else if (faviconResponse.data?.url) {
            setFaviconUrl(faviconResponse.data.url);
          } else {
            console.error("No favicon URL or filename in response:", faviconResponse.data);
          }
        } catch (error) {
          console.error("Favicon fetch error:", error);
        }
      } catch (error) {
        console.error('Error fetching images:', error);
      }
    };

    fetchImages();
  }, []);

  const checkImageDimensions = (file: File): Promise<boolean> => {
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => {
        resolve(img.width <= 100 && img.height <= 100);
      };
      img.src = URL.createObjectURL(file);
    });
  };

  const allowedFileTypes = ["jpg", "jpeg", "png", "gif"];

  const isValidFileType = (file: File) => {
    const fileExtension = file.name.split('.').pop()?.toLowerCase();
    return fileExtension && allowedFileTypes.includes(fileExtension);
  };

  const handleFile = async (e: File) => {
    if (!isValidFileType(e)) {
      ErrorToast('Please upload only JPG, JPEG, PNG, or GIF files');
      return;
    }

    const isValidSize = await checkImageDimensions(e);
    if (!isValidSize) {
      ErrorToast('Please upload 100x100 size only');
      return;
    }

    setFile(e);
  };

  const handleFavicon = async (e: File) => {
    if (!isValidFileType(e)) {
      ErrorToast('Please upload only JPG, JPEG, PNG, or GIF files');
      return;
    }

    const isValidSize = await checkImageDimensions(e);
    if (!isValidSize) {
      ErrorToast('Please upload 100x100 size only');
      return;
    }

    setFavIcon(e);
  };

  const selectLogo = () => {
    logoRef?.current?.click()
  }

  const selectFavIcon = () => {
    faviconRef?.current?.click()
  }

  const handleUpload = async () => {
    setIsLoading(true);
    try {
      // if (file) {
      //   const uniqueFileName = `${'logo'.replace(/\s+/g, '_')}_${Date.now()}`;
      //   const logoUrl = await uploadImage(file, uniqueFileName, 'Logo', 'Logo');
      //   await uploadLogoToBackend(logoUrl, file);
      // }

      if (file) {
        
        const uniqueFileName = `${'logo'.replace(/\s+/g, '_')}_${Date.now()}`;
        const logoUrl = await uploadImage(file, uniqueFileName, 'Logo', 'Logo');
        await uploadLogoToBackend(logoUrl, file);
        setLogoUrl(logoUrl);
      }

      if (favIcon) {
        const uniqueFileName = `${'favicon'.replace(/\s+/g, '_')}_${Date.now()}`;
        const faviconUrl = await uploadImage(favIcon, uniqueFileName, 'Logo', 'Favicon');
        await uploadFaviconToBackend(faviconUrl, favIcon);
        setFaviconUrl(faviconUrl);
      }

      SuccessToast('Logo and Favicon uploaded successfully');
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    } catch (error) {
      console.error('Error uploading images:', error);
      ErrorToast('Failed to upload images');
    }
    finally {
      setIsLoading(false);
    }
  }

  const uploadLogoToBackend = async (imageUrl: string, file: File) => {
    try {
      const response = await _axios.post(`${BASE_URL}/api/logo/upload-url`, {
        image_url: imageUrl,
        mimetype: file.type,
        size: file.size
      });
      if (response.data.success !== 1) {
        throw new Error(response.data.message || 'Failed to update logo');
      }
    } catch (error) {
      console.error('Error uploading logo to backend:', error);
      throw error;
    }
  }

  const uploadFaviconToBackend = async (imageUrl: string, file: File) => {
    try {
      const response = await _axios.post(`${BASE_URL}/api/favicon/upload-url`, {
        image_url: imageUrl,
        mimetype: file.type,
        size: file.size
      });
      if (response.data.success !== 1) {
        throw new Error(response.data.message || 'Failed to update favicon');
      }
    } catch (error) {
      console.error('Error uploading favicon to backend:', error);
      throw error;
    }
  }

  const handleImageError = (e: React.SyntheticEvent<HTMLImageElement, Event>, type: string) => {
    console.error(`Error loading ${type}`);
    console.error(`URL that failed: ${type === 'logo' ? logoUrl : faviconUrl}`);
    e.currentTarget.style.display = 'none';
    if (type === 'logo') {
      setLogoUrl('');
      console.log('Reset logo URL');
    } else {
      setFaviconUrl('');
      console.log('Reset favicon URL');
    }
  };

  return (
    <div>
      <div className={style.bodyBox}>
        {/* Main content here */}
        <div className={style.bodyHeading}>
          <p className={style.bodytitle}>Logo Upload</p>
        </div>
        <div className={style.logoUploadContainer}>
          <div className={style.uploadSection}>
            <div>
              <label className={style.labelLogo}>Logo  <span className="text-grey-600">{'[Please Upload Image of size 100x100 pixels only]'}</span> </label>
              <div className='flex' style={{ paddingBottom: '20px' }}>
                <FileUploader handleChange={handleFile} name="file" children={
                  file ? (
                    <div className={style.singleUpload}>
                      <div className="flex rounded-md border-inherit border p-2">

                        <button className='px-7 py-2 text-white bg-yellow-500 rounded-lg '>Browse</button>
                        <small className="pl-4 self-center">{file.name}</small>
                      </div>
                    </div>
                  ) : (
                    <div className="d-flex justify-content-between">
                      <div className="flex flex-row items-center rounded-md border p-2 w-full sm:w-3/4 lg:w-1/2">
                        <button className="px-7 py-2 text-white bg-yellow-500 rounded-lg">Browse</button>
                        <small className="pl-4 self-center">Drag and Drop file here</small>
                      </div>
                      <div className='w-35 sm:w-3/4 lg:w-1/2'>
                        {/* <img
                          src={`${BASE_URL}/api/logo`}
                          alt="Logo"
                          className={style.companyIcon}
                        /> */}
                        {logoUrl && (
                          <img
                            src={logoUrl}
                            alt="Logo"
                            className={style.companyIcon}
                            onError={(e) => handleImageError(e, 'logo')}
                          />
                        )}
                      </div>
                    </div>
                  )
                } />
                {file && <div className='bg-slate-300 rounded-lg py-5 px-7 mx-4 self-center'>
                  <img src={URL.createObjectURL(file)} alt="Logo" className={`${style.cloudUpload}`} />
                </div>}
                {file && <i
                  onClick={() => setFile(null)}
                  className="fa fa fa-trash"
                  style={{ color: "red" }}
                ></i>}
                {!file}
              </div>
            </div>

            <div>
              <label className={style.labelLogo}>Favicon <span className="text-grey-600">{'[Please Upload Image of size 100x100 pixels only]'}</span> </label>
              <div className='flex' style={{ paddingBottom: '20px' }}>
                <FileUploader handleChange={handleFavicon} name="file" children={
                  favIcon ? (
                    <div className={style.singleUpload}>
                      <div className="flex rounded-md border-inherit border p-2">
                        <button className='px-7 py-2 text-white bg-yellow-500 rounded-lg '>Browse</button>
                        <small className="pl-4 self-center">{favIcon.name}</small>
                      </div>
                    </div>
                  ) : (
                    <div className="d-flex justify-content-between">
                      <div className="flex flex-row items-center rounded-md border p-2 w-full sm:w-3/4 lg:w-1/2">
                        <button className="px-7 py-2 text-white bg-yellow-500 rounded-lg">Browse</button>
                        <small className="pl-4 self-center">Drag and Drop file here</small>
                      </div>
                      <div className='w-35 sm:w-3/4 lg:w-1/2'>
                        {/* <img
                          src={`${BASE_URL}/api/favicon`}
                          alt="Favicon"
                          className={style.companyIcon}
                        /> */}
                        {faviconUrl ? (
                          <img
                            src={faviconUrl}
                            alt="Favicon"
                            className={style.companyIcon}
                            onError={(e) => {
                              console.error('Favicon loading error:', e);
                              console.error('Attempted favicon URL:', faviconUrl);
                              handleImageError(e, 'favicon');
                            }}
                            onLoad={() => console.log('Favicon loaded successfully')}
                          />
                        ) : (
                          <div>No favicon URL available</div>
                        )}
                      </div>
                    </div>
                  )
                } />
                {favIcon && <div className='bg-slate-300 rounded-lg py-5 px-7 mx-4 self-center'>
                  <img src={URL.createObjectURL(favIcon)} alt="Logo" className={`${style.cloudUpload}`} />
                </div>}
                {favIcon && <i
                  onClick={() => setFavIcon(null)}
                  className="fa fa fa-trash"
                  style={{ color: "red" }}
                ></i>}
                {!favIcon}
              </div>
            </div>
          </div>

          <div className={style.buttonSection}>
            <button className={style.publishButton} onClick={handleUpload}>Publish</button>
            <button className={style.closeButton} onClick={() => navigate('/dashboard')}>Close</button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Logo